export const ANALYTICS = 'analytics';
export const THUNK = 'thunk';
